import { useState } from "react";
import { guideSteps } from "@/mocks/content";

const demoLines = [
  { name: "主线路 · 超清", status: "在线", quality: "1080P", delay: "18ms" },
  { name: "备用线路 · 高清", status: "在线", quality: "720P", delay: "24ms" },
  { name: "备用线路 · 流畅", status: "在线", quality: "540P", delay: "31ms" },
  { name: "备用线路 · 极速", status: "高峰拥堵", quality: "480P", delay: "108ms" },
];

export default function Guide() {
  const [activeStep, setActiveStep] = useState(0);
  const [currentLine, setCurrentLine] = useState(0);

  return (
    <section id="guide" className="w-full bg-background-100 py-20 md:py-24">
      <div className="container-site">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-block rounded-full bg-secondary-100 px-4 py-1.5 text-sm font-semibold text-secondary-900">
            线路指南
          </span>
          <h2 className="mt-5 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            三步上手,秒切线路不卡顿
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-700">
            跟随以下步骤,搭配小猴看番的自动选源与手动秒切,轻松解决看番卡顿问题。
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 items-stretch gap-8 lg:grid-cols-2">
          {/* 步骤列表 */}
          <div className="flex flex-col gap-4">
            {guideSteps.map((step, index) => (
              <button
                key={step.num}
                type="button"
                onClick={() => setActiveStep(index)}
                className={`flex items-start gap-4 rounded-lg border p-5 text-left transition-all duration-300 ${
                  activeStep === index
                    ? "border-primary-300 bg-background-50 shadow-sm"
                    : "border-background-200 bg-background-50/60 hover:border-background-300"
                }`}
              >
                <span
                  className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-xl transition-colors ${
                    activeStep === index ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                  }`}
                >
                  <i className={step.icon} aria-hidden="true"></i>
                </span>
                <span>
                  <span className="flex items-center gap-2">
                    <span className="font-heading text-sm font-bold text-secondary-600">{step.num}</span>
                    <span className="text-base font-bold text-foreground-950">{step.title}</span>
                  </span>
                  <span className="mt-1 block text-sm leading-relaxed text-foreground-700">{step.desc}</span>
                </span>
              </button>
            ))}
          </div>

          {/* 线路演示面板 */}
          <div className="flex flex-col overflow-hidden rounded-lg border border-background-200 bg-foreground-950 text-background-50">
            <div className="flex items-center gap-3 border-b border-background-800 bg-foreground-900 px-5 py-4">
              <span className="flex h-3 w-3 rounded-full bg-primary-500"></span>
              <span className="text-sm font-semibold">小猴看番 · 线路控制台</span>
              <span className="ml-auto rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">
                自动选源已开启
              </span>
            </div>

            <div className="flex flex-1 flex-col justify-between gap-6 p-6">
              <div className="flex items-center justify-between rounded-lg bg-background-800/60 px-4 py-3">
                <span className="text-sm text-background-200">当前线路</span>
                <span className="text-sm font-bold text-secondary-300">{demoLines[currentLine].name}</span>
              </div>

              <ul className="flex flex-col gap-2.5">
                {demoLines.map((line, index) => {
                  const blocked = index === demoLines.length - 1;
                  const active = index === currentLine;
                  return (
                    <li key={line.name}>
                      <button
                        type="button"
                        onClick={() => !blocked && setCurrentLine(index)}
                        disabled={blocked}
                        className={`flex w-full items-center justify-between rounded-md border px-4 py-3 text-sm transition-colors ${
                          active
                            ? "border-accent-400 bg-accent-500/15 text-background-50"
                            : "border-background-800 bg-background-900 text-background-200 hover:border-background-700"
                        } ${blocked ? "cursor-not-allowed opacity-60" : "cursor-pointer"}`}
                      >
                        <span className="flex items-center gap-2">
                          {active && <i className="ri-checkbox-circle-fill text-accent-300" aria-hidden="true"></i>}
                          {!active && !blocked && <i className="ri-circle-line text-background-500" aria-hidden="true"></i>}
                          {blocked && <i className="ri-timer-line text-secondary-400" aria-hidden="true"></i>}
                          {line.name}
                        </span>
                        <span className="flex items-center gap-3">
                          <span className="hidden text-xs text-background-400 sm:inline">{line.quality}</span>
                          <span
                            className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${
                              blocked ? "bg-secondary-500/20 text-secondary-300" : "bg-accent-500/20 text-accent-300"
                            }`}
                          >
                            {line.status}
                          </span>
                        </span>
                      </button>
                    </li>
                  );
                })}
              </ul>

              <p className="rounded-lg bg-background-800/40 px-4 py-3 text-xs leading-relaxed text-background-300">
                <i className="ri-lightbulb-line mr-1 text-secondary-300" aria-hidden="true"></i>
                提示:点击任意可用线路即可秒切,播放进度自动续播,高峰拥堵的线路已自动为你避让。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}